<template>
  <div class="w-25 flex flex-wrap justify-center gap-1">
    <div
      v-for="website in mostVisitedWebsites"
      :key="website.rid"
      draggable="true"
      class="group flex h-28 w-28 flex-col justify-center rounded transition-all duration-300 hover:bg-[#e8e8e8] dark:hover:bg-[#505050]"
      :title="website.title"
    >
      <button
        class="z-3 transition-duration-500 invisible z-10 ml-auto mr-1 mt-1 h-5 w-5 rounded-full text-sm text-gray-400 hover:bg-gray-300 hover:text-black focus:outline-none group-hover:visible dark:text-gray-500 dark:hover:bg-gray-600 dark:hover:text-gray-300"
        draggable="false"
        @click="removeShortcut(website)"
      >
        X
      </button>

      <a
        :href="website.url"
        class="mt-[-20px] flex h-full w-full flex-col items-center justify-center border-0 text-center"
        target="_blank"
        draggable="false"
      >
        <div class="flex h-12 w-12 rounded-full border-0 bg-[#e1e3e1] p-[12px] dark:bg-[#454746]">
          <img
            :src="website.faviconUrl"
            alt="Website Logo"
            class="h-[24px] w-[24px] rounded-full border-0 bg-gray-100 dark:bg-gray-600"
          />
        </div>

        <div class="mt-2 w-full text-center dark:text-gray-200">
          <span class="text-sm">{{ truncate(website.title) }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { truncate } from '~/utils/string'

  type Website = {
    rid: number
    title: string
    url: string
    faviconUrl: string
  }

  const mostVisitedWebsites = ref<Website[]>([])

  onMounted(async () => {
    const builtInShortcuts = window?.chrome?.embeddedSearch?.newTabPage?.mostVisited
    const userShortcuts = (await window?.chrome?.topSites.get()) || []

    if (!builtInShortcuts || !userShortcuts) return

    mostVisitedWebsites.value = builtInShortcuts.map<Website>((s, i) => ({
      ...s,
      ...(userShortcuts[i] || {}),
    }))
  })

  const removeShortcut = (website: Website) => {
    mostVisitedWebsites.value = mostVisitedWebsites.value.filter((s) => s.rid !== website.rid)
    window?.chrome?.embeddedSearch?.newTabPage?.deleteMostVisitedItem(website.rid)
  }
</script>
